import { activeHelperAgreementBundle } from "../config/helperAgreementBundle";

const helperAgreementDocuments = new Map(
  activeHelperAgreementBundle.documents.map((document) => [
    document.slug,
    document,
  ]),
);

const dockerOwnedPublicAsset = (filename) =>
  `/assets/${encodeURIComponent(filename)}`;

export const legalDocuments = [
  {
    slug: "terms-of-service",
    title: "Terms of Service",
    ...helperAgreementDocuments.get("terms-of-service"),
  },
  {
    slug: "privacy-policy",
    title: "Privacy Policy",
    ...helperAgreementDocuments.get("privacy-policy"),
  },
  {
    slug: "code-of-conduct",
    title: "Code of Conduct",
    url: dockerOwnedPublicAsset("Code of Conduct.txt"),
  },
  {
    slug: "safety-policy",
    title: "Safety Policy",
    url: dockerOwnedPublicAsset("Safety Policy.txt"),
  },
  {
    slug: "cancellation-and-refund-policy",
    title: "Cancellation and Refund Policy",
    url: dockerOwnedPublicAsset("Cancellation and Refund Policy.txt"),
  },
  {
    slug: "independent-contractor-agreement",
    title: "Independent Contractor Agreement",
    ...helperAgreementDocuments.get("independent-contractor-agreement"),
  },
  {
    slug: "general-liability-waiver",
    title: "General Liability Waiver",
    ...helperAgreementDocuments.get("general-liability-waiver"),
  },
  {
    slug: "parent-guardian-authorization-agreement",
    title: "Parent and Guardian Authorization Agreement",
    url: dockerOwnedPublicAsset(
      "Parent and Guardian Authorization Agreement.txt",
    ),
  },
  {
    slug: "helper-handbook",
    title: "Helper Handbook",
    url: dockerOwnedPublicAsset("Helper Handbook.txt"),
  },
];
